import React, { Component } from 'react';
import { Accordion, AccordionPanel, Button, Icon } from '@salesforce/design-system-react';

import { CONFERENCE_NAME } from '../../constants';
import { keynotes } from '../../data';
import BrowserContainer from '../../containers/browserContainer';

class Session extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTranscript: false
    };
  }

  renderInfo() {
    const session = this.props.session;
    return (
      <dl className='slds-list_horizontal slds-wrap pts'>

        <dt className='slds-item_label ptxs'>
          <Icon
            assistiveText={{ label: 'Date & Time' }}
            category='utility'
            name='clock'
            size='small'
            title='Date & Time'
          />
        </dt>
        <dd className='slds-item_detail ptxs'>{session.date} &middot; {session.time}</dd>

        <dt className='slds-item_label ptxs'>
          <Icon
            assistiveText={{ label: 'Location' }}
            category='utility'
            name='location'
            size='small'
            title='Location'
          />
        </dt>
        <dd className='slds-item_detail ptxs'>{session.location}</dd>

        <dt className='slds-item_label pvxs'>
          <Icon
            assistiveText={{ label: 'Description' }}
            category='utility'
            name='description'
            size='small'
            title='Description'
          />
        </dt>
        <dd className='slds-item_detail pvxs'>{session.blurb}</dd>  
      </dl>
    );
  }

  renderCaptionTrack() {
    if (this.props.accessible) {
      return (
        <track
          default
          kind='captions'
          src={this.props.session.captionSrc}
          srclang='English'
        />
      )
    }
    return null;
  }

  renderTranscript() {
    if (this.props.accessible) {
      return (
        <Accordion>
          <AccordionPanel
            expanded={this.state.showTranscript}
            id={'transcript' + this.props.session.id}
            onTogglePanel={() => {this.setState({showTranscript: !this.state.showTranscript})}}
            summary='Transcript'>
            {this.props.session.transcript}
          </AccordionPanel>
        </Accordion>
      )
    }
  }

  renderVideo() {
    return (
      <video width='100%' height='auto' className='pvm' controls muted >
        <source src={this.props.session.videoSrc} type='video/mp4'/>
        {this.renderCaptionTrack()}
        Whoops, your browser doesn't support embedded videos! Sorry about your luck.
      </video>
    )
  }

  render() {
    const session = this.props.session;
    return (
      <article className='slds-box mas session bg-white'>
        <h3>{session.title}</h3>
        {this.renderInfo()}
        <h4 className='ptm slds-text-heading_medium'>What to expect</h4>
        {this.renderVideo()}
        {this.renderTranscript()}
        <Button
          className='mvm pam slds-align_absolute-center'
          disabled={this.props.nextDisabled}
          iconCategory='action'
          iconName='log_event'
          iconPosition='left'
          label={`Register for ${session.title}`}
          onClick={this.props.nextFunc}
        />
      </article>
    );
  }
}

class KeynoteSelectorScreen extends Component {
  render() {
    return (
      <BrowserContainer label={`Keynotes at ${CONFERENCE_NAME}`}>
        <section>
          <div className='pvm phl'>
            <h2 className='slds-align_absolute-center pam'>Day 2 Keynotes</h2>
              {/*<p>
                {CONFERENCE_NAME} has some amazing speakers this year!
                There are so many inspiring leaders joining us, in fact,
                that we've had to double up on time slots. Preview these
                speakers' unique stories below and choose a Day 2
                Keynote to attend. 
              </p>*/}
          </div>
          <ul className='slds-grid mas'>
            {keynotes.map((session, i) => { return (
                <li key={i} className='slds-col slds-size_1-of-2'>
                  <Session
                    session={session}
                    accessible={this.props.accessible}
                    nextFunc={this.props.nextFunc}
                    nextDisabled={this.props.nextDisabled}
                  />
                </li>
            )})}
          </ul>
        </section>
      </BrowserContainer>
    );
  }
}

export default KeynoteSelectorScreen;



// WEBPACK FOOTER //
// ./src/steps/captions/keynoteSelectorScreen.js